import { createAsyncThunk } from '@reduxjs/toolkit'
import {
  takePlo6SeatService,
  takePlo6ActionService,
  updatePlo6PlayerSittingStatusService,
  updatePlo6PlayerSitOutNextBBService,
  updatePlo6BuyInAmountService,
  changePlo6SeatService,
  getPlo6GameTablesService,
  runItTwiceDecisionService
} from 'network/services/Plo6GameManagement.service'

export const getPlo6GameTablesThunk = createAsyncThunk(
  'plo6/getGameTables',
  async ({ data}, { rejectWithValue }) => {
    try {
      const response = await getPlo6GameTablesService(data)
      return response
    } catch (error) {
      return rejectWithValue('Failed to fetch game tables')
    }
  }
)

export const takePlo6SeatThunk = createAsyncThunk(
  'plo6/takeSeat',
  async (data, { rejectWithValue }) => {
    try {
      const response = await takePlo6SeatService(data)
      return response.data?.data || response.data
    } catch (error) {
      console.error('Error taking Plo6 seat:', error)
      return rejectWithValue(error.response?.data?.message || error.message || 'Failed to take seat')
    }
  }
)

export const takePlo6ActionThunk = createAsyncThunk(
  'plo6/takeAction',
  async (data, { rejectWithValue }) => {
    try {
      const response = await takePlo6ActionService(data)
      return response.data?.data || response.data
    } catch (error) {
      console.error('Error taking Plo6 action:', error)
      return rejectWithValue(error.response?.data?.message || error.message || 'Failed to take action')
    }
  }
)

export const updatePlo6PlayerSittingStatusThunk = createAsyncThunk(
  'plo6/updatePlayerSittingStatus',
  async (data, { rejectWithValue }) => {
    try {
      const response = await updatePlo6PlayerSittingStatusService(data)
      return response.data?.data || response.data
    } catch (error) {
      console.error('Error updating Plo6 player sitting status:', error)
      return rejectWithValue(error.response?.data?.message || error.message || 'Failed to update sitting status')
    }
  }
)

export const updatePlo6PlayerSitOutNextBBThunk = createAsyncThunk(
  'plo6/updatePlayerSitOutNextBB',
  async (data, { rejectWithValue }) => {
    try {
      const response = await updatePlo6PlayerSitOutNextBBService(data)
      return response.data?.data || response.data
    } catch (error) {
      console.error('Error updating Plo6 player sit out next BB:', error)
      return rejectWithValue(error.response?.data?.message || error.message || 'Failed to update sit out next BB')
    }
  }
)

export const updatePlo6BuyInAmountThunk = createAsyncThunk(
  'plo6/updateBuyInAmount',
  async (data, { rejectWithValue }) => {
    try {
      const response = await updatePlo6BuyInAmountService(data)
      return response.data?.data || response.data
    } catch (error) {
      console.error('Error updating Plo6 buy-in amount:', error)
      return rejectWithValue(error.response?.data?.message || error.message || 'Failed to update buy-in amount')
    }
  }
)

export const changePlo6SeatThunk = createAsyncThunk(
  'plo6/changeSeat',
  async (data, { rejectWithValue }) => {
    try {
      const response = await changePlo6SeatService(data)
      return response.data?.data || response.data
    } catch (error) {
      console.error('Error changing Plo6 seat:', error)
      return rejectWithValue(error.response?.data?.message || error.message || 'Failed to change seat')
    }
  }
)

export const runItTwiceDecisionThunk = createAsyncThunk(
  'plo6/runItTwiceDecision',
  async (data, { rejectWithValue }) => {
    try {
      const response = await runItTwiceDecisionService(data)
      return response.data?.data || response.data
    } catch (error) {
      console.error('Error submitting run it twice decision:', error)
      return rejectWithValue(error.response?.data?.message || error.message || 'Failed to submit decision')
    }
  }
)
